import { Eyebrow, Reveal, SectionTitle } from "./Reveal";
import { HIGHLIGHTS } from "./data";

export default function Highlights() {
  return (
    <section id="highlights" data-testid="highlights-section" className="bg-ivory">
      <div className="mx-auto max-w-editorial px-6 py-24 md:px-10 md:py-32">
        <Reveal>
          <Eyebrow center>Moments that stay with you</Eyebrow>
        </Reveal>
        <Reveal delay={0.12}>
          <SectionTitle before="Journey" accent="Highlights" center className="mt-7" />
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mx-auto mt-7 h-px w-16 bg-saffron/50" aria-hidden="true" />
        </Reveal>

        <div className="mt-16 grid gap-5 md:grid-cols-2">
          {HIGHLIGHTS.map((h, i) => (
            <Reveal
              key={h.index}
              delay={(i % 2) * 0.08}
              className="group border border-ink/10 bg-cream p-7 transition-all duration-500 hover:border-saffron/50 hover:shadow-md md:p-8"
            >
              <div data-testid={`highlight-${h.index}`} className="flex items-center gap-6">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-saffron/15 font-serif text-lg italic text-saffron">
                  {h.index}
                </span>
                <div>
                  <h3 className="font-serif text-xl font-light leading-snug text-ink transition-colors duration-300 group-hover:text-leaf md:text-2xl">
                    {h.title}
                  </h3>
                  <p className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.26em] text-saffron">{h.day}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
